import React from 'react';
import './Ornaments.scss';

// ============================================================================
// Ornate section heading with Om divider
// ============================================================================
export function SectionHeading({ chip, title, subtitle, light = false, align = 'center', noDivider = false }) {
  return (
    <div className={`orn-heading ${light ? 'light' : ''} align-${align}`}>
      {chip && <span className="orn-chip">{chip}</span>}
      <h2 className="orn-title">{title}</h2>
      {!noDivider && (
        <div className="orn-divider" aria-hidden="true">
          <span className="div-line"></span>
          <span className="div-om">ॐ</span>
          <span className="div-line"></span>
        </div>
      )}
      {subtitle && <p className="orn-subtitle">{subtitle}</p>}
    </div>
  );
}

// ============================================================================
// Decorative clay lamp (diya) with flickering flame
// ============================================================================
export function Diya({ className = '' }) {
  return (
    <span className={`diya ${className}`} aria-hidden="true">
      <span className="diya-flame">
        <span className="flame-inner"></span>
      </span>
      <span className="diya-bowl"></span>
      <span className="diya-glow"></span>
    </span>
  );
}

// ============================================================================
// Decorative line row of diyas
// ============================================================================
export function DiyaRow({ count = 3, className = '' }) {
  return (
    <div className={`diya-row ${className}`} aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <Diya key={i} />
      ))}
    </div>
  );
}

// ============================================================================
// Ornate temple arch frame for a portrait / image
// ============================================================================
export function TempleArch({ children, className = '' }) {
  return (
    <div className={`temple-arch ${className}`}>
      <div className="arch-inner">
        <span className="arch-corner tl"></span>
        <span className="arch-corner tr"></span>
        <span className="arch-corner bl"></span>
        <span className="arch-corner br"></span>
        <div className="arch-image">{children}</div>
        <span className="arch-pedestal"></span>
      </div>
    </div>
  );
}

// ============================================================================
// Animated golden rays behind the portrait (divine aura)
// ============================================================================
export function GoldenAura({ className = '' }) {
  return (
    <div className={`golden-aura ${className}`} aria-hidden="true">
      <div className="aura-rays"></div>
      <div className="aura-ring ring-1"></div>
      <div className="aura-ring ring-2"></div>
      <span className="aura-om">ॐ</span>
    </div>
  );
}

// ============================================================================
// Soft radial mandala background layer
// ============================================================================
export function MandalaBg({ className = '' }) {
  return <div className={`mandala-bg ${className}`} aria-hidden="true" />;
}
